export const SCORE_PATH = "/free-ai-growth-audit/";
export const SCORE_LABEL = "Check my AI visibility";

/**
 * The first visible paragraph on each commercial hub is intentionally reused as
 * the first FAQ answer. This keeps the claim, visible copy and FAQPage schema
 * aligned without claiming a guaranteed ranking, citation or commercial result.
 */
export const AEO_HUB_FIRST_ANSWER =
  "An Answer Engine Optimisation (AEO) agency makes a sourced, signed claim easy for an answer engine to quote, then checks whether that visibility brings in the right lead. Generative Engine Optimisation (GEO) applies the same discipline across AI search surfaces. Neither approach can promise a ranking or citation date.";

export const IMC_HUB_FIRST_ANSWER =
  "An integrated marketing communications agency aligns the buyer, message, channels and measurement in one commercial plan. In an AI-era programme, search, answer-ready content, paid media and sales handoffs should reinforce the same decision rather than produce separate reports. Attribution still needs a named owner, evidence and a documented method.";

export const ABM_HUB_FIRST_ANSWER =
  "An account-based marketing agency helps a B2B team choose named accounts, map the buying group and run the messages, channels and sales handoffs that support a specific commercial decision. It is not broad lead generation with a new label, and it cannot guarantee meetings, pipeline or revenue.";

export const UK_DELIVERY_NOTE = "We work with B2B teams across the UK, remotely.";
